//Yes or No
export const BOOLEAN_FIELDS = ['TDPNotice', 'DFWPRelease', 'noShowStatus', 'DataTransfer', 'TestCompleted', 'MembershipReceived', 'Majority', 'GovernerApproved', 'ElectionRequired', 'GroundRulesEstablished', 'PPE1_FLAG', 'PPE2_FLAG', 'PPE3_FLAG'];

//Active, Inactive or N/A
export const STATUS_FIELDS = ['TDPPosition', 'DTResultAppealed', 'TDPPositionStatus', 'ProcessEligibility', 'empStatus', "DepartmentStatus"];

//Show As Button
export const BUTTON_TYPE_FIELDS = ["Operation", "operation"];
export const CUSTOME_BUTTON_STATUS_FIELDS = ["DeductionPlanStatus", "Deduction_plan_Status", "ActiveStatus"];